import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconExplosion: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconExplosion"><Path d="M12.0009 1.1123L9.55283 5.86395L1.9988 1.99783L5.86492 9.55185L1.11328 11.9999L5.96558 14.4998L4.30218 19.6986L9.50097 18.0352L12.0009 22.8875L14.4489 18.1358L22.0029 22.002L18.1368 14.4479L22.8885 11.9999L18.0362 9.49999L19.6996 4.30121L14.5008 5.9646L12.0009 1.1123Z" fill="currentColor"/></CentralIconBase>;
});

export default IconExplosion;
